import React, { memo, useCallback, useMemo } from 'react';
import { cx } from '@emotion/css';
import { Branch as BranchIcon, Button } from '../../../../../atoms';
import { getPredefinedViewPermissions } from '../../ViewsMenu.service';
import useStyles from './PredefinedView.styles';
export const PredefinedView = memo(function ({ active, disabled, className, id, onClick, view, }) {
    const classes = useStyles();
    const [isOpeningAllowed] = useMemo(() => {
        const { open } = getPredefinedViewPermissions(view);
        return [open];
    }, [view]);
    const handleClick = useCallback(() => {
        onClick();
    }, [onClick]);
    return (React.createElement(Button, { className: cx(className, classes.root, {
            active,
            disabled,
            openingDisallowed: !isOpeningAllowed,
        }), id: id, disabled: active || disabled || !isOpeningAllowed, disableRipple: active || disabled || !isOpeningAllowed, onClick: handleClick },
        React.createElement("span", { className: cx(classes.viewName, { active }) }, view.name),
        React.createElement(BranchIcon, { className: classes.branchIcon })));
});
//# sourceMappingURL=PredefinedView.js.map